// extracted by mini-css-extract-plugin
export default {"container":"forgot_container__KMl5n","form":"forgot_form__+gQLM","input":"forgot_input__ch+2+","button":"forgot_button__19l64"};